var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronBackward(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.79999 5.99688L6.69999 9.89688C6.88332 10.0802 6.97499 10.3135 6.97499 10.5969C6.97499 10.8802 6.88332 11.1135 6.69999 11.2969C6.51665 11.4802 6.28332 11.5719 5.99999 11.5719C5.71665 11.5719 5.48332 11.4802 5.29999 11.2969L0.699988 6.69688C0.599988 6.59688 0.529154 6.48854 0.487488 6.37188C0.445821 6.25521 0.424988 6.13021 0.424988 5.99688C0.424988 5.86354 0.445821 5.73854 0.487488 5.62188C0.529154 5.50521 0.599988 5.39687 0.699988 5.29688L5.29999 0.696875C5.48332 0.513542 5.71665 0.421875 5.99999 0.421875C6.28332 0.421875 6.51665 0.513542 6.69999 0.696875C6.88332 0.880208 6.97499 1.11354 6.97499 1.39688C6.97499 1.68021 6.88332 1.91354 6.69999 2.09688L2.79999 5.99688Z",
    fill: "#F6F6F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronBackward);
export default __webpack_public_path__ + "static/media/chevron_backward.ffdf714affef3590be1c0e7edecb88ca.svg";
export { ForwardRef as ReactComponent };